import gql from 'graphql-tag';
import { GetBannersService } from '../services/get-banners.service';

export const addbannerdata = gql`
  mutation InsertBannerCategory($banner: banner_categories_insert_input!) {
    insert_banner_categories(objects: [$banner]) {
      affected_rows
    }
  }
`;

export const addbanner = gql`
  mutation InsertBannerCategory($banner: banners_insert_input!) {
    insert_banners(objects: [$banner]) {
      affected_rows
    }
  }
`;


// export const getBannersCategoryData = gql`
//   query getBannersCategoryFilter($status: String!, $search: String!) {
//     banner_categories(
//       where: {
//         status: { _eq: $status },
//         name: { _ilike: $search }
//       },
//       order_by: { created_at: desc } 
//     ) {
//       id
//       name
//       dimensions
//       banner_location
//       timer
      
//       created_at
//       updated_at
//       status
//     }
//   }
// `;

export const getBannersCategoryDatas = gql`
  query getBannersCategoryFilter($where: banner_categories_bool_exp) {
    banner_categories(
      where: $where,
      order_by: { created_at: desc }
    ) {
      id
      name
      dimensions
      banner_location
      timer
      created_at
      updated_at
      status
    }
  }
`;



export const getBannersDatas = gql`
  query getBannersDatas($where: banners_bool_exp, $limit: Int, $offset: Int) {
    banners(where: $where, limit: $limit, offset: $offset ,order_by: { created_at: desc }) 
     {
      status
      expiry_date
      image
      schedule_date
      banner_name
      category_name
      company_name
      created_at
      updated_at
      from_id
      id
      views
      dental_suppliers {
        id
        name
        type
      }
    }
    banners_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;



export const updatebannerdata = gql`
  mutation UpdateBannerCategory($id: uuid!, $data: banner_categories_set_input!) {
    update_banner_categories_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      name
      dimensions
      banner_location
      timer
      
      status
    }
  }
`;


export const updateBannerCategory = gql`
 mutation UpdateBannerCategory($id: uuid!, $data: banner_categories_set_input!) {
  update_banner_categories_by_pk(pk_columns: { id: $id }, _set: $data) {
    id
    name
    dimensions
    banner_location
    timer
    
    status
  }
}
`;
export const updateBanner = gql`
 mutation UpdateBanner($id: uuid!, $data: banners_set_input!) {
  update_banners_by_pk(pk_columns: { id: $id }, _set: $data) {
		id
    views
  }
}
`;


export const updateBannerCategoryStatus = gql`
  mutation UpdateBannerCategoryStatus($id: uuid!, $status: String!) {
    update_banner_categories_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`;

export const deleteBannerCategoryById = gql`
  mutation deleteBannerCategory($id: uuid!) {
    delete_banner_categories_by_pk(id: $id) {
      id
    }
  }
`;
export const deleteBannerById = gql`
  mutation deleteBanner($id: uuid!) {
    delete_banners_by_pk(id: $id) {
      id
    }
  }
`;

export const getBannerCategoryById = gql`
  query GetBannerCategoryById($id: uuid!) {
    banner_categories_by_pk(id: $id) {
      id
      name
      dimensions
      banner_location
      timer
      

    }
  }
`;
export const getBannerById = gql`
  query GetBannerById($id: uuid!) {
    banners_by_pk(id: $id) {
      status
		expiry_date
		image
		schedule_date
		banner_name
    url
		category_name
		created_at
		updated_at
		from_id
		id
    }
  }
`;

export const getBannerCountsQuery = gql`
  query GetBannerCounts($today: jsonb!, $adminId: uuid!) {
    all: banners_aggregate(
      where: {
        _or: [
          { status: { _neq: "DRAFT" } },
          { status: { _eq: "DRAFT" }, from_id: { _eq: $adminId } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }

    draft: banners_aggregate(
      where: { status: { _eq: "DRAFT" }, from_id: { _eq: $adminId } }
    ) {
      aggregate {
        count
      }
    }

    pending: banners_aggregate(where: { status: { _eq: "PENDING" } }) {
      aggregate {
        count
      }
    }

    approved: banners_aggregate(where: { status: { _eq: "APPROVED" } }) {
      aggregate {
        count
      }
    }

    rejected: banners_aggregate(where: { status: { _eq: "REJECTED" } }) {
      aggregate {
        count
      }
    }

    expired: banners_aggregate(where: { expiry_date: { _lt: $today } }) {
      aggregate {
        count
      }
    }
  }
`;

export const getSupplierBannerCountsQuery = gql`
  query GetSupplierBannerCounts($today: jsonb!, $supplierId: uuid!) {
    all: banners_aggregate(
      where: { from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    draft: banners_aggregate(
      where: { status: { _eq: "DRAFT" }, from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    pending: banners_aggregate(
      where: { status: { _eq: "PENDING" }, from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    approved: banners_aggregate(
      where: { status: { _eq: "APPROVED" }, from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    rejected: banners_aggregate(
      where: { status: { _eq: "REJECTED" }, from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    expired: banners_aggregate(
      where: { expiry_date: { _lt: $today }, from_id: { _eq: $supplierId } }
    ) {
      aggregate { count }
    }
    
  }
`;

export const updateBannerStatusMutation = gql`
  mutation UpdateExpiredBanners($id: [uuid!]!, $status: String!) {
    update_banners(
      where: { id: { _in: $id } },
      _set: { status: $status }
    ) {
      affected_rows
      returning {
        id
        status
      }
    }
  }
`;

export const getMonthlyBannersCountQuery = gql`
subscription getMonthlyBannersCountSubscription($andList: [banners_bool_exp!]) {
  banners_aggregate(where: {_and: $andList}) {
    aggregate {
      count
    }
  }
}`;
export const filterStatusApproveMutation = gql`
  query filterStatusApprove($company_name: String!, $category_name: String!) {
    banners(
      where: {
        company_name: { _eq: $company_name },
        category_name: { _eq: $category_name },
        status: { _eq: "APPROVED" }
      }
    ) {
      id
      created_at
      updated_at
      company_name
      status
      dental_suppliers {
        id
        name
        email
        phone
        profile_image
        logo
      }
    }
  }
`;

export const getAllbannerData = gql`
  query GetAllBannerData(
    $status: String, 
    $category_names: [String!], 
    $banner_location: [String!]
  ) {
    banners(
      where: {
        status: { _eq: $status },
        category_name: { _in: $category_names },
        banner_categories: {
          banner_location: { _has_keys_any: $banner_location }
        }
      },
      order_by: { created_at: desc }
    ) {
      id
      category_name
      expiry_date
      image
      schedule_date
      views
      url
      company_name
   
      banner_categories {
        id
        name
        banner_location
        timer
      }
    }
  }
`;




